<template lang="pug">
  ItemRows(
    :items="category_getItems(title)"
    :category="title"
    source="category_item")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import type { PropType } from "vue"
import { mapGetters } from "vuex"
import { CATEGORY_ITEMS } from "~/store/item-category"
import { GET_ITEMS } from "~/store/item-category"

export default defineComponent({
  name: "MoveItemsDesktop",
  props: {
    label: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array as PropType<Item[]>,
      required: true
    }
  },
  computed: {
    ...mapGetters("item-category", {
      category_getItems: GET_ITEMS
    })
  },

  mounted() {
    this.$store.dispatch("item-category/" + CATEGORY_ITEMS, {
      key: this.title,
      items: this.items
    })
  }
})
</script>

<style lang="css" module>
@import "~/assets/scss/iolp.scss";

.content {
  ul {
    @apply grid px-ds-md;
  }

  .item {
    @apply flex flex-col justify-between;

    p {
      @apply leading-2xl text-center select-none;
    }

    .itemControls {
      @apply grid grid-cols-3 gap-ds-md;

      div {
        @apply cursor-pointer;
      }

      p {
        @apply min-w-ds-ml m-auto leading-normal border-[1px] border-black20 select-none;
      }
    }
  }
}
</style>
